import React from "react";
import { ResponsiveC } from "../topbar/Topbar";
import styled from "styled-components";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { globalTheme } from "../../product/config/themes";
import { CardActionArea, CardMedia, Typography } from "@mui/material";

export const MainContainer = styled.div`
  background-color: ${(props) => props.theme.colors.misc3};
  padding-top: 60px;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 80px;
  overflow: hidden;
`;

const Cloud = styled.svg`
  position: absolute;
  left: 5%;
  bottom: 5%;
  height: 169px;
  width: 239px;
  fill: #004c80;
  opacity: 0.02;
`;

export const TitleC = styled.div`
  padding: 0 30px;
  flex: 0.4;

  @media (min-width: 1280px) {
    position: relative;
    padding: 20px 80px 0 50px;
  }
`;

export const ResponsiveContainer = styled(ResponsiveC)`
  display: inline-block;
`;

export const PrimaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 0;
  @media (min-width: 1280px) {
    flex-direction: row;
    padding: 60px 0;
  }
`;

// @ts-ignore
const Container = styled(Stack)(() => ({
  minHeight: "100%",
  padding: "5em",
  display: "flex",

  "&::before": {
    content: '""',
    display: "block",
    position: "absolute",
    zIndex: -1,
    inset: 0,
    backgroundImage:
      "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
  },
}));

const Welcome = (): JSX.Element => {
  return (
    <ThemeProvider theme={globalTheme}>
      <CssBaseline enableColorScheme />
      <Container
        alignItems={"center"}
        minHeight={"100vh"}
        flexDirection={"row"}
        justifyContent={"center"}
        gap={5}
      >
        <Stack
          sx={{
            maxWidth: { sm: "100%", md: "645px" },
          }}
        >
          <Typography variant={"h5"} textAlign={"center"}>
            Herzlich Willkommen bei HeavenHR 2.0.
          </Typography>
          <Typography variant={"h5"} textAlign={"center"}>
            Bitte wählen Sie aus, ob Sie unsere Open Beta oder schon HeavenHR
            2.0 nutzen?
          </Typography>
          <Stack
            justifyContent={"space-around"}
            alignItems={"stretch"}
            gap={4}
            flexDirection={"row"}
            padding={"2em"}
          >
            <Card
              elevation={0}
              sx={{
                maxWidth: { sm: "100%" },
                boxShadow: `0 0 0 1px rgba(17, 25, 39, 0.04)`,
              }}
            >
              <CardActionArea
                href={"https://heavenhr2.com/app/login"}
                sx={{ height: "100%", width: "245px" }}
              >
                <CardMedia
                  component="img"
                  height="120"
                  sx={{ objectFit: "contain", padding: "25px 25px 0 25px" }}
                  image={"img/heavenhr-logo.png"}
                  alt={""}
                />
                <CardContent sx={{ height: "100%" }}>
                  <Typography
                    textAlign="center"
                    gutterBottom
                    variant="h6"
                    component="div"
                  >
                    {"zum Login"}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
            <Card
              elevation={0}
              style={{
                marginTop: "0",
              }}
              sx={{
                maxWidth: { sm: "100%" },
                boxShadow: `0 0 0 1px rgba(17, 25, 39, 0.04)`,
              }}
            >
              <CardActionArea
                href={"https://heavenhr.com/web/DE/de/login"}
                sx={{ height: "100%", width: "245px" }}
              >
                <CardMedia
                  component="img"
                  height="120"
                  sx={{ objectFit: "contain", padding: "25px 25px 0 25px" }}
                  image={"img/hhr_logo.png"}
                  alt={""}
                />
                <CardContent sx={{ height: "100%" }}>
                  <Typography
                    textAlign="center"
                    gutterBottom
                    variant="h6"
                    component="div"
                  >
                    {"zur Website"}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Stack>
        </Stack>
        <Cloud viewBox="0 0 501.702 354.441">
          <path
            id="Path_103"
            d="M301.3.6c-50.78,0-96.481,26.405-122.887,69.06-12.187-7.109-25.39-11.172-39.608-11.172-41.639,0-76.169,33.515-79.216,75.154A119.358,119.358,0,0,0,1.7,236.217c0,65,52.811,118.824,116.793,118.824H386.609c65,0,116.793-52.811,116.793-118.824a119.358,119.358,0,0,0-57.889-102.575C438.4,58.489,376.453.6,301.3.6Z"
            transform="translate(-1.7 -0.6)"
          ></path>
        </Cloud>
      </Container>
    </ThemeProvider>
  );
};

export default Welcome;
